var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeakerWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.996,
    height: 34.002,
    viewBox: "0 0 29.996 34.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KASOOKOO_IN-APP_VOICE_CALLING",
    "data-name": "KASOOKOO IN-APP VOICE CALLING",
    transform: "translate(-30.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2177",
    "data-name": "Group 2177",
    transform: "translate(42.489 0.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2176",
    "data-name": "Group 2176",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19388",
    "data-name": "Path 19388",
    d: "M232.825,17.944,219.564,4.682A1.993,1.993,0,1,0,216.745,7.5l13.262,13.262a1.992,1.992,0,0,0,2.817-2.817Z",
    transform: "translate(-216.163 -4.1)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2179",
    "data-name": "Group 2179",
    transform: "translate(37.265 5.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2178",
    "data-name": "Group 2178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19389",
    "data-name": "Path 19389",
    d: "M142.316,82.905l-.1.5a21.414,21.414,0,0,1-4.723,9.566l7.215,7.215a21.342,21.342,0,0,1,9.519-4.769l.5-.1Z",
    transform: "translate(-137.494 -82.905)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2181",
    "data-name": "Group 2181",
    transform: "translate(30.136 17.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2180",
    "data-name": "Group 2180",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19390",
    "data-name": "Path 19390",
    d: "M35.942,256.989l-4.931,4.93a2.988,2.988,0,0,0,0,4.227l2.817,2.817a2.988,2.988,0,0,0,4.227,0l4.93-4.93Zm.7,7.748a1,1,0,1,1-1.409-1.409l1.409-1.409a1,1,0,0,1,1.409,1.409Z",
    transform: "translate(-30.136 -256.989)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2183",
    "data-name": "Group 2183",
    transform: "translate(40.872 22.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2182",
    "data-name": "Group 2182",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19391",
    "data-name": "Path 19391",
    d: "M198.085,352.663l1.355-1.355a2.986,2.986,0,0,0,0-4.225l-1.006-1.007a18.867,18.867,0,0,0-1.6,1.213l1.2,1.2a.994.994,0,0,1,0,1.408l-1.377,1.377-2.024-1.961-2.817,2.817,4.519,4.379a1.992,1.992,0,0,0,2.816-2.819Z",
    transform: "translate(-191.813 -346.075)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2185",
    "data-name": "Group 2185",
    transform: "translate(50.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2184",
    "data-name": "Group 2184",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19392",
    "data-name": "Path 19392",
    d: "M332.86,0a1,1,0,0,0-1,1V2.988a1,1,0,1,0,1.992,0V1A1,1,0,0,0,332.86,0Z",
    transform: "translate(-331.864)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2187",
    "data-name": "Group 2187",
    transform: "translate(56.149 7.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2186",
    "data-name": "Group 2186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19393",
    "data-name": "Path 19393",
    d: "M424.852,120H422.86a1,1,0,1,0,0,1.992h1.992a1,1,0,1,0,0-1.992Z",
    transform: "translate(-421.864 -120)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2189",
    "data-name": "Group 2189",
    transform: "translate(54.157 1.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2188",
    "data-name": "Group 2188",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19394",
    "data-name": "Path 19394",
    d: "M395.556,30.292a1,1,0,0,0-1.409,0l-1.992,1.992a1,1,0,0,0,1.409,1.409l1.992-1.992A1,1,0,0,0,395.556,30.292Z",
    transform: "translate(-391.864 -30)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerWhiteIcon);
export default __webpack_public_path__ + "static/media/speaker_white_icon.95a2644a4104b35ea062811637599dbf.svg";
export { ForwardRef as ReactComponent };